import {Injectable} from '@angular/core';
import {FrameService} from './frame.service';
import {ActionAbstract} from '../../../models/actions/action.abstract';
import {Store} from '@ngrx/store';
import VideoState from '../stores/root-store/video.state';

@Injectable({
    providedIn: 'root'
})
export class ActionService {
    private _frameActionTable = {
    };

    constructor(private frameService: FrameService, private store: Store<{ video: VideoState }>) {
    }

    get frameActionTable(): {} {
        return this._frameActionTable;
    }

    createTimeActionTable(actions: ActionAbstract[]) {
        actions.forEach((action) => {
            const frameToPerform = action.getFrameToPerform(this.frameService);
            if (this._frameActionTable.hasOwnProperty(frameToPerform)) {
                this._frameActionTable[frameToPerform].push(action);
            } else {
                this._frameActionTable[frameToPerform] = [action];
            }
        });
    }

    checkAndPerformAction(frame) {
        let isPerformed = false;
        if (this._frameActionTable.hasOwnProperty(frame)) {
            this._frameActionTable[frame].forEach((action: ActionAbstract) => {
                action.performAction(this.store, this.frameService);
                isPerformed = true;
            });
        }

        return isPerformed;
    }
}
